import { render } from "./UserEditView.vue?vue&type=template&id=05dcb506"
import script from "./UserEditView.vue?vue&type=script&lang=js"
export * from "./UserEditView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__